<template>
  <md-toolbar
    class="md-transparent"
    md-elevation="0"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          PGI
        </h3>
      </div>

      <div class="md-toolbar-section-end">
        <button
          class="entity-button"
          type="button"
          role="button"
          :disabled="!rootEntity"
          @click="showEntityDialog()"
        >
          <template v-if="activeEntity">
            {{ activeEntity.name }}
          </template>
          <template v-else>
            Entidade
          </template>
        </button>

        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { findEntities, getEntityById } from "@/_services/entity.service";
import { getUserSession } from "@/_services/localstorage";
import EntitySelector from "@/components/EntitySelector.vue";
import { EventBus, events } from "@/_helpers/event-bus";

export default {
  name: "TopNavbar",
  data: () => ({
    /** @type {Entity | null} */
    activeEntity: null,

    /** @type {Entity | null} */
    rootEntity: null,
  }),
  async created() {
    this.$progress.start();
    this.user = getUserSession();

    [
      this.activeEntity,
      this.rootEntity
    ] = await Promise.all([
      getEntityById(this.user.activeentity),
      findEntities(),
    ]);

    EventBus.$on(events.CHANGED_ENTITY, this.onChangeEntity);

    this.$progress.stop();
  },
  beforeDestroy() {
    EventBus.$off(events.CHANGED_ENTITY, this.onChangeEntity);
  },
  methods: {
    showEntityDialog() {
      if (!this.rootEntity) {
        return;
      }

      this.$modal.show(
        EntitySelector,
        {
          rootEntity: this.rootEntity,
        },
        {
          name: "EntitySelector",
          height: "600px",
          width: "600px",
          shiftX: 0.5,
        }
      );
    },

    onChangeEntity(entity) {
      this.activeEntity = entity;
      this.user = getUserSession();
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
  },
};
</script>

<style lang="scss">
.entity-button {
  display: inline-block;
  padding: 0.75rem 2rem;

  outline: none;
  border: none;
  border-radius: 3px;

  cursor: pointer;

  transition: box-shadow .2s cubic-bezier(0.4, 0, 1, 1),
  background-color .2s cubic-bezier(0.4, 0, 0.2, 1);

  box-shadow: 0 2px 2px 0 rgba(153, 153, 153, .14),
  0 3px 1px -2px rgba(153, 153, 153, .2),
  0 1px 5px 0 rgba(153, 153, 153, .12);

  &[disabled] {
    cursor: wait;
  }

  &:not([disabled]) {
    &:hover, &:focus {
      box-shadow: 0 14px 26px -12px rgba(153, 153, 153, .42),
      0 4px 23px 0px rgba(0, 0, 0, .12),
      0 8px 10px -5px rgba(153, 153, 153, .2);
    }
  }

}

</style>
